import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultComponent } from './result.component';
import { NzResultModule } from 'ng-zorro-antd/result';
import { SharedUiModule } from '../../shared-ui.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { LottieComponent } from 'ngx-lottie';

@NgModule({
    imports: [
        CommonModule,
        SharedUiModule,
        NzResultModule,
        NzLayoutModule,
        LottieComponent,
    ],
    declarations: [ResultComponent],
    exports: [ResultComponent],
})
export class ResultModule {}
